import {Injectable} from '@angular/core';
import {AlertService} from '../notify/alert.service';
import {ModalSettingsModel} from '../../models/modal.model';
import {ModalService} from '../modal/modal.service';
import {DepartmentModel, DepartmentUserModel, DivisionModel} from '../../models/department.model';
import {MemberModel} from '../../models/user.model';
import {HelpersService} from '../helpers.service';
import {DepartmentsService} from '../api/departments.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class DepartmentControlService {

    public DictionaryList: {} = {};
    public departmentList: DepartmentModel[] = [];

    constructor(
        protected departmentApi: DepartmentsService,
        protected alertService: AlertService,
        protected modalService: ModalService,
        protected helper: HelpersService,
        public translate: TranslateService
    ) {
    }

    getDepartmentList(forced = false): Promise<DepartmentModel[] | boolean> {
        return new Promise(resolve => {
            if (this.departmentList.length && !forced) {
                resolve(this.departmentList);
            } else {
                this.departmentApi.getDepartments().subscribe({
                    next: data => {
                        const departmentsWithIdInIndex = {};
                        this.departmentList = data.departments;
                        for (const department of data.departments) {
                            departmentsWithIdInIndex[department.id] = department;
                        }
                        this.DictionaryList = departmentsWithIdInIndex;
                        resolve(data.departments);
                    },
                    error: error => {
                        this.alertService.setAlert(error.message, 'blue');
                        resolve(false);
                    },
                });
            }
        });
    }

    deleteDepartment(departmentId: number): Promise<boolean> {
        return new Promise(resolve => {
            let modalSettings: ModalSettingsModel;
            modalSettings = {
                modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
                modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_DEPARTMENT'),
                buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
                buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
            };
            const modal = this.modalService.createFromSettings(modalSettings);
            modal.result.then(data => {
                if (data) {
                    this.departmentApi.deleteDepartment({id: departmentId}).subscribe({
                        next: data2 => {
                            resolve(true);
                            this.alertService.setAlert(data2.message, 'green');
                        }, error: error => {
                            resolve(false);
                            this.alertService.setAlert(error.message, 'blue');
                        },
                    });
                } else {
                    resolve(false);
                }
            }).catch(() => {
                resolve(false);
            });
        });
    }

    getDepartmentUsers(departmentId: number): Promise<DepartmentUserModel[] | boolean> {
        return new Promise((resolve, reject) => {
            const sub = this.departmentApi.getDepartmentUsers(departmentId).subscribe({
                next: data => {
                    sub.unsubscribe();
                    resolve(data.users);
                }, error: () => {
                    reject(false);
                },
            });
        });
    }

    deleteUserFromDepartment(departmentId: number, user: DepartmentUserModel): Promise<boolean> {
        return new Promise(resolve => {
            let modalSettings: ModalSettingsModel;
            modalSettings = {
                modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
                modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_MEMBER', {name: this.helper.fullName(user.member)}),
                buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
                buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
            };
            const modal = this.modalService.createFromSettings(modalSettings);
            modal.result.then(data => {
                if (data) {
                    this.departmentApi.deleteUserFromDepartment({
                        id: departmentId,
                        guid: user.member.guid,
                    }).subscribe({
                        next: data2 => {
                            resolve(true);
                            this.alertService.setAlert(data2.message, 'green');
                        }, error: error => {
                            resolve(false);
                            this.alertService.setAlert(error.message, 'blue');
                        },
                    });
                } else {
                    resolve(false);
                }
            }).catch(() => {
                resolve(false);
            });
        });
    }

    /**
     * inviteUserInDepartment(departmentId, userMail, rights): Promise<{
     *     message: string,
     *     department_id: number,
     *     user: MemberModel
     * }> {
     *     return new Promise (resolve => {
     *         const data = {
     *             id: departmentId,
     *             email: userMail,
     *             observ: rights.value
     *         };
     *         this.departmentApi.inviteUserToDepartment(data).subscribe(result => {
     *             resolve(result);
     *         }, error => {
     *             this.alertService.setAlert(error.message, 'blue');
     *         });
     *     });
     * }
     */

    createDepartment(name: { name: string; }): Promise<boolean> {
        return new Promise(resolve => {
            this.departmentApi.createDepartment(name).subscribe({
                next: data2 => {
                    resolve(true);
                    this.alertService.setAlert(data2.message, 'green');
                }, error: error => {
                    resolve(false);
                    this.alertService.setAlert(error.message, 'blue');
                },
            });
        });
    }

    async getDivisions(departmentId: number): Promise<{
        divisions: DivisionModel[],
        department: DepartmentModel,
        members: {
            [key: string]: MemberModel
        }
    }> {
        return new Promise((resolve) => {
            this.departmentApi.getDepartmentDivisions(departmentId).subscribe({
                next: res => {
                    resolve(res.department);
                }
            });
        });
    }
}
